// Admin API client — /admin/feature-flags/* (mirrors the API's feature-flags aggregate).

import type { FeatureFlags, FeatureFlagDoc } from '@a7y/types';
import { client } from './transport';

export const featureFlagsApi = {
  // Feature Flags
  getFeatureFlags: () =>
    client.get<{ flags: FeatureFlags; documents: FeatureFlagDoc[] }>('/feature-flags'),
  updateFeatureFlag: (flagName: string, data: { enabled: boolean; description?: string }) =>
    client.post<{ message: string; flagName: string; enabled: boolean }>(
      `/feature-flags/${flagName}`,
      data
    ),
};
